export const useGoogleOneTap = ({
  callback,
}: {
  callback: (credential: string) => void
}) => ({
  prompt: () => {
    if (!window.google?.accounts) {
      console.log('google client not initialized')
      return
    }

    window.google.accounts.id.initialize({
      client_id: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID as string,
      callback: (response) => callback(response.credential),
    })

    window.google.accounts.id.prompt()
  },
})
